import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {Alert, AlertType} from '../models/miscellaneous/alert';
import {filter} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  private subject = new Subject<Alert>();
  private defaultId = 'default-alert';

  constructor(private translate: TranslateService) {
  }

  onAlert(id = this.defaultId): Observable<Alert> {
    return this.subject.asObservable().pipe(filter(x => x && x.id === id));
  }

  success(message: string, options?: any): void {
    message = this.translate.instant(message);
    this.alert(new Alert({...options, type: AlertType.Success, message}));
  }

  error(message: string, options?: any): void {
    message = this.translate.instant(message);
    this.alert(new Alert({...options, type: AlertType.Error, message}));
  }

  info(message: string, options?: any): void {
    message = this.translate.instant(message);
    this.alert(new Alert({...options, type: AlertType.Info, message}));
  }

  warn(message: string, options?: any): void {
    message = this.translate.instant(message);
    this.alert(new Alert({...options, type: AlertType.Warning, message}));
  }

  alert(alert: Alert): void {
    alert.id = alert.id || this.defaultId;
    this.subject.next(alert);
  }

  clear(id = this.defaultId): void {
    this.subject.next(new Alert({id}));
  }
}
